import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdownWithAnchors from '@/components/VueMarkdownWithAnchors.vue';
import Loading from '@/components/Loading.vue';
const blobsModule = namespace('blobs');
let MonsterChapter = class MonsterChapter extends Vue {
    constructor() {
        super(...arguments);
        this.chapterMap = {
            introduction: 'Introduction',
            creatingEncounters: 'Creating Encounters',
            monsters: 'Monsters'
        };
    }
    created() {
        this.fetchMonsterBlob(this.blobName);
    }
    fetchData() {
        this.fetchMonsterBlob(this.blobName);
    }
    get blobName() {
        return this.chapterMap[this.chapter];
    }
    get blob() {
        const blob = this.monsterBlobs[this.blobName];
        return blob && blob.replace(/\ufffd/g, ' - ');
    }
};
__decorate([
    blobsModule.State
], MonsterChapter.prototype, "monsterBlobs", void 0);
__decorate([
    blobsModule.Action
], MonsterChapter.prototype, "fetchMonsterBlob", void 0);
__decorate([
    Prop(String)
], MonsterChapter.prototype, "chapter", void 0);
__decorate([
    Watch('$route')
], MonsterChapter.prototype, "fetchData", null);
MonsterChapter = __decorate([
    Component({
        components: {
            VueMarkdownWithAnchors,
            Loading
        }
    })
], MonsterChapter);
export default MonsterChapter;
